import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AdminProvider } from './context/AdminContext';

// Root pages
import Landing from './pages/landing';


// Student pages
import StudentDashboard from './pages/student/StudentDashboard';
import MyCourses from './pages/student/mycourses';
import Certificates from './pages/student/certificates';
import CourseOverview from './pages/student/CourseOverview';
import Profile from './pages/student/profile';
import Support from './pages/student/support';
import PaymentSuccess from './pages/student/PaymentSuccess';

// Student pages
import CertificateApplication from './pages/student/CertificateApplication';

// Admin pages
import AdminDashboard from './pages/admin/admindashboard';
import ManageCourse from './pages/admin/managecourse';
import ManagementStudents from './pages/admin/ManagementStudents';
import AdminSettings from './pages/admin/AdminSettings';
import FlashSaleManager from './pages/admin/FlashSaleManager';
import VisitorLogs from './pages/admin/VisitorLogs';
import CertificateOrders from './pages/admin/CertificateOrders';
import InstructorApplications from './pages/admin/InstructorApplications';
import ContactMessages from './pages/admin/ContactMessages';

// Footer pages
import TeachOnELearn from './pages/footer/TeachOnELearn';
import GetTheApp from './pages/footer/GetTheApp';
import AboutUs from './pages/footer/AboutUs';
import ContactUs from './pages/footer/ContactUs';
import Blog from './pages/footer/Blog';
import HelpSupport from './pages/footer/HelpSupport';
import Affiliate from './pages/footer/Affiliate';
import Investors from './pages/footer/Investors';
import TermsOfService from './pages/footer/TermsOfService';
import PrivacyPolicy from './pages/footer/PrivacyPolicy';
import SitemapPage from './pages/footer/SitemapPage';
import Accessibility from './pages/footer/Accessibility';

// Components
import AdminLayout from './components/AdminLayout';
import StudentLayout from './components/StudentLayout';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <AuthProvider>
      <AdminProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Landing />} />
              <Route path="/teach-on-elearn" element={<TeachOnELearn />} />
              <Route path="/get-the-app" element={<GetTheApp />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/help-and-support" element={<HelpSupport />} />
              <Route path="/affiliate" element={<Affiliate />} />
              <Route path="/investors" element={<Investors />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/sitemap" element={<SitemapPage />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/apply-certificate" element={<CertificateApplication />} />


              {/* Student Routes */}
              <Route path="/student/dashboard" element={
                <StudentLayout>
                  <StudentDashboard />
                </StudentLayout>
              } />
              <Route path="/student/mycourses" element={
                <StudentLayout>
                  <MyCourses />
                </StudentLayout>
              } />
              <Route path="/student/certificates" element={
                <StudentLayout>
                  <Certificates />
                </StudentLayout>
              } />
              <Route path="/courseoverview" element={
                <StudentLayout>
                  <CourseOverview />
                </StudentLayout>
              } />
              <Route path="/student/profile" element={
                <StudentLayout>
                  <Profile />
                </StudentLayout>
              } />
              <Route path="/student/support" element={
                <StudentLayout>
                  <Support />
                </StudentLayout>
              } />
              <Route path="/payment/success" element={
                <StudentLayout>
                  <PaymentSuccess />
                </StudentLayout>
              } />



              {/* Admin Routes */}
              <Route path="/login/admin" element={<Navigate to="/" replace />} />
              <Route path="/admin" element={<Navigate to="/" replace />} />

              <Route path="/admin/admindashboard" element={
                <AdminLayout currentPage="dashboard">
                  <AdminDashboard />
                </AdminLayout>
              } />
              <Route path="/admin/managecourse" element={
                <AdminLayout currentPage="courses">
                  <ManageCourse />
                </AdminLayout>
              } />
              <Route path="/admin/managecourse/:courseId" element={
                <AdminLayout currentPage="courses">
                  <ManageCourse />
                </AdminLayout>
              } />
              <Route path="/admin/ManagementStudents" element={
                <AdminLayout currentPage="students">
                  <ManagementStudents />
                </AdminLayout>
              } />
              <Route path="/admin/settings" element={
                <AdminLayout currentPage="settings">
                  <AdminSettings />
                </AdminLayout>
              } />
              <Route path="/admin/flash-sale" element={
                <AdminLayout currentPage="flash-sale">
                  <FlashSaleManager />
                </AdminLayout>
              } />
              <Route path="/admin/visitors" element={
                <AdminLayout currentPage="visitors">
                  <VisitorLogs />
                </AdminLayout>
              } />
              <Route path="/admin/certificates" element={
                <AdminLayout currentPage="certificates">
                  <CertificateOrders />
                </AdminLayout>
              } />
              <Route path="/admin/instructors" element={
                <AdminLayout currentPage="instructors">
                  <InstructorApplications />
                </AdminLayout>
              } />
              <Route path="/admin/contact-messages" element={
                <AdminLayout currentPage="contact-messages">
                  <ContactMessages />
                </AdminLayout>
              } />
            </Routes>
          </div>
        </Router>
      </AdminProvider>
    </AuthProvider>
  );
}

export default App;